const CreateAC = "/api/v1/ac";
const CreateReportCode = "/api/v1/report_code";
const CheckReportCode = "/api/v1/report_code/check_code";
export { CreateAC, CreateReportCode, CheckReportCode };
